import React from 'react'
import {Marker, Popup} from 'react-leaflet'
import {slottsskogenPosition} from '../../common/utils/slottsskogenPosition'
import {Box} from '../../webui/Box'
import {GenericMap, ZOOM_MANY_MARKERS} from '../location/map/GenericMap'
import {ActionsPopupContent} from './ActionsPopupContent'
import {resolveActionIcon} from './resolveActionIcon'
import {ActionsMarker} from './types/actionsMarker'
import {resolveActionLevel} from './utils/resolveActionLevel'

interface Props {
  actions: ActionsMarker[]
  center?: [number, number]
  height?: string
  minHeight?: string | number
  zoom?: number
}

export const ActionsMap: React.FC<Props> = ({actions, center, height = '100%', minHeight, zoom}) => {
  const actionMarkers = actions

  const mapCenter =
    center ??
    (actionMarkers.length > 0 ? ([actionMarkers[0].coordinates.lat, actionMarkers[0].coordinates.long] as [number, number]) : slottsskogenPosition)

  return (
    <Box sx={{width: '100%', '& .leaflet-container': {borderRadius: 0}}}>
      <GenericMap initialPosition={mapCenter} zoom={zoom ?? ZOOM_MANY_MARKERS} height={height} minHeight={minHeight ?? 300}>
        {actionMarkers.map((marker) => (
          <Marker icon={resolveActionIcon(resolveActionLevel(marker))} key={marker.id} position={[marker.coordinates.lat, marker.coordinates.long]}>
            <Popup minWidth={500}>
              <ActionsPopupContent marker={marker} />
            </Popup>
          </Marker>
        ))}
      </GenericMap>
    </Box>
  )
}
